import { PUT_USER_EMAIL } from '../actionTypes/NativeAppActionTypes';

const NativeAppUserDetailsReducer = function NativeAppUserDetailsReducer(state = {}, action) {
    switch (action.type) {
        case PUT_USER_EMAIL:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

NativeAppUserDetailsReducer.reducerName = 'nativeAppUserDetails';

export default NativeAppUserDetailsReducer;
